import React, { useState, useEffect } from "react";
import { FaStream, FaUserCircle, FaUserAlt } from "react-icons/fa";
import brandUTH from "../../assets/images/brand.png";
import Cookies from "universal-cookie";
import Timer from "../Main/Timer";
import FootBar from "./FootBar";

require("../../assets/stylesheets/Utils/NavBar.css");

const cookie = new Cookies();

function Menu() {
  const [menuVisibility, setMenuVisibility] = useState(false);
  const [photo, setPhoto] = useState("");

  const changeMenuVisibility = () => {
    setMenuVisibility((current) => !current);
  };

  useEffect(() => {}, [menuVisibility]);

  const logout = () => {
    cookie.remove("id", { path: "/" });
    cookie.remove("username", { path: "/" });
    cookie.remove("email", { path: "/" });
    cookie.remove("likes", { path: "/" });
    cookie.remove("level", { path: "/" });
    cookie.remove("judge", { path: "/" });
    cookie.remove("admin", { path: "/" });
    cookie.remove("photo", { path: "/" });
    window.open("https://ferias-ingenio-backend.vercel.app/api/auth/logout", "_self");
  };

  window.oncontextmenu = function () {
    changeMenuVisibility();
    return false;
  };

  return (
    <div className="menu-container">
      <button
        onClick={changeMenuVisibility}
        className={menuVisibility ? "btn-menu-on" : "btn-menu-off"}
      >
        <div></div>
        <div></div>
        <div></div>
      </button>
      <div
        className={menuVisibility ? "menu-back" : "hide-menu"}
        onClick={changeMenuVisibility}
      >
        <div className={menuVisibility ? "menu" : "hide-menu"}>
          {cookie.get("username") && (
            <div className="username" title="En Sesión">
              <span>
                {cookie.get("photo") ? (
                  <img
                    className="user-avatar"
                    src={cookie.get("photo")}
                    alt={cookie.get("username")}
                  />
                ) : (
                  <FaUserAlt className="user-avatar" />
                )}
              </span>{" "}
              {cookie.get("username")}
            </div>
          )}
          <a href="/categories">
            <div className="btn">Proyectos</div>
          </a>
          {!cookie.get("username") && (
            <a href="/account">
              <div className="btn">Ingresar</div>
            </a>
          )}
          <a href="/inscribe">
            <div className="btn">Inscribirse</div>
          </a>
          <a href="/history">
            <div className="btn">Historia</div>
          </a>
          <a href="/tutorials">
            <div className="btn">Tutoriales</div>
          </a>
          {cookie.get("judge") && (
            <a href="/judges">
              <div className="btn">Evaluar Proyectos</div>
            </a>
          )}
          {cookie.get("admin") && (
            <a href="/administration">
              <div className="btn">Administración</div>
            </a>
          )}
          {cookie.get("username") && (
            <a onClick={logout}>
              <div className="btn">Cerrar Sesión</div>
            </a>
          )}
          <FootBar />
        </div>
      </div>
    </div>
  );
}

// <Timer
//       month="October"
//       day="4"
//       year="2022"
//       hour="18:00:00"
//       endMessage="¡PREPARANDO EL SIGUIENTE EVENTO!"
//       link="https://uth-hn.zoom.us/j/91802373205"
//     />

function NavBar() {
  return (
    <nav className="navbar">
      <div className="brand">
        <a href="/">
          <img src={brandUTH} alt="UTH Brand" />
        </a>
      </div>
      <div className="navbar-decoration">
      </div>
      <div className="options">
        <Menu />
      </div>
    </nav>
  );
}

export default NavBar;
